import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Context = /*#__PURE__*/React.createContext(null);
class ApiProvider extends React.Component {
  render() {
    const {
      children,
      api
    } = this.props;
    if (!children) {
      return null;
    }
    return /*#__PURE__*/_jsx(Context.Provider, {
      value: api,
      children: children
    });
  }
}
ApiProvider.Context = Context;
export default ApiProvider;